export default "__VITE_ASSET__Dgbk4lh8__"